import React from 'react';
import './SocialFeature.css';

const TikTokFeature = () => {
    const tiktokUrl = "https://www.tiktok.com/@dannymahan";

    return (
        <div className="social-feature">
            <h2>TikTok Videos</h2>
            {/* Add TikTok embed code here */}
            <a 
                href={tiktokUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="social-button tiktok-button"
            >
                Follow Me on TikTok
            </a>
        </div>
    );
};

export default TikTokFeature; 